"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomesticInfoResponseSchema = exports.DomesticInfoRequestBodySchema = void 0;
var zod_1 = require("zod");
exports.DomesticInfoRequestBodySchema = zod_1.z.object({
    pageName: zod_1.z.enum(['MOTEL', 'HOTEL', 'PENSION', 'GUESTHOUSE', 'AREA', 'AROUND', 'KEYWORD']),
    checkInDate: zod_1.z.string().nullish(),
    checkOutDate: zod_1.z.string().nullish(),
    capacityAdults: zod_1.z.number().nullish(),
    childrenAges: zod_1.z.array(zod_1.z.number()).nullish(),
    /** 위도 */
    latitude: zod_1.z.number().nullish(),
    /** 경도 */
    longitude: zod_1.z.number().nullish(),
    /** 위경도 측위 방식 (DEFAULT, GPS, MANUAL) */
    locationType: zod_1.z.string().nullish(),
    /** 위경도 측위 시간 (Unix Timestamp 형식) */
    locationTime: zod_1.z.number().nullish(),
    searchType: zod_1.z.string().nullish(),
    /** 검색 키워드 - (SRP)일 때 필수 */
    keyword: zod_1.z.string().nullish(),
    /** 모호펜게 상권 코드. (서브홈PLP에서 사용) */
    region: zod_1.z.number().nullish(),
    /** 정렬 순서 */
    sort: zod_1.z.string().nullish(),
});
exports.DomesticInfoResponseSchema = zod_1.z.object({
    header: zod_1.z.object({
        title: zod_1.z.object({
            type: zod_1.z.enum(['TEXT', 'INPUT']),
            title: zod_1.z.string(),
        }),
        icons: zod_1.z.object({
            left: zod_1.z.array(zod_1.z.object({
                type: zod_1.z.enum(['HOME', 'SEARCH', 'BACK', 'CART']),
                link: zod_1.z.string(),
                altText: zod_1.z.string(),
                logMeta: zod_1.z.any(),
            })),
            right: zod_1.z.array(zod_1.z.object({
                type: zod_1.z.enum(['HOME', 'SEARCH', 'BACK', 'CART']),
                link: zod_1.z.string(),
                altText: zod_1.z.string(),
                logMeta: zod_1.z.any(),
            })),
        }),
        location: zod_1.z
            .object({
            type: zod_1.z.enum(['REGION', 'AREA', 'AROUND']),
            title: zod_1.z.string().optional(),
            data: zod_1.z.any().optional(),
            logMeta: zod_1.z.any(),
        })
            .optional(),
        tab: zod_1.z
            .object({
            items: zod_1.z.array(zod_1.z.object({
                searchType: zod_1.z.string(),
                title: zod_1.z.string(),
                pathname: zod_1.z.string(),
                logMeta: zod_1.z.any(),
            })),
            initalIndex: zod_1.z.number(),
            logMeta: zod_1.z.any(),
        })
            .optional(),
    }),
    body: zod_1.z.object({
        isShowItemTypeLabel: zod_1.z.boolean(),
        isShowToTopButton: zod_1.z.boolean(),
        isShowLeisureSwitchButton: zod_1.z.boolean(),
        gnb: zod_1.z
            .object({
            selectedType: zod_1.z.string(),
        })
            .optional(),
    }),
});
